/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.components

import japgolly.scalajs.react._
import japgolly.scalajs.react.extra._
import japgolly.scalajs.react.extra.router.RouterCtl
import japgolly.scalajs.react.vdom.html_<^._
import net.scalytica.blaargh.CssSettings._
import net.scalytica.blaargh.models.Config
import net.scalytica.blaargh.pages.Views._
import net.scalytica.blaargh.styles.{BlaarghBootstrapCSS, LinerleSVG}
import org.scalajs.dom
import scalacss.ScalaCssReact._

object Menu {

  object Styles extends StyleSheet.Inline {

    import dsl._

    val blaarghBrand = style("blaargh-brand")(
      position absolute,
      top `0`,
      left `0`,
      marginTop(0.4 em),
      marginLeft(5 rem),
      cursor pointer,
      unsafeChild("svg")(
        height(30 px),
        width(40 px),
        unsafeChild("path")(svgFill := "white")
      )
    )

    val menu = styleF("dynamic-menu").bool { showSolidMenu =>
      styleS(
        addClassNames("menu"),
        boxShadow := "0px 13px 16px -4px rgba(0,0,0,0.75)",
        mixinIfElse(showSolidMenu)(
          backgroundColor white,
          unsafeChild(".blaargh-brand svg path")(svgFill := "black"),
          unsafeChild(".menuitem")(
            unsafeChild(".menuitem-label")(
              color.black,
              &.hover(
                color.black,
                textShadow := "2px 1px 1px white"
              )
            )
          )
        )(backgroundColor rgba (225, 225, 225, 0.1)),
        transitionProperty := "background-color, color, box-shadow",
        BlaarghBootstrapCSS.Mixins.easeOutAnimation
      )
    }
  }

  case class Props(siteConfig: Config, currPage: View, ctl: RouterCtl[View])

  case class State(isScrolling: Boolean = false)

  class Backend($ : BackendScope[Props, State]) extends OnUnmount {

    def onScroll: Callback =
      $.state.flatMap { _ =>
        if (dom.window.pageYOffset > 5.0) $.setState(State(isScrolling = true))
        else $.setState(State())
      }

    def onClick(evt: ReactEvent, target: View with ViewType): Callback =
      Callback {
        evt.preventDefault()
        Option(dom.document.getElementById(target.basePath_NoPrefix)).fold {
          $.props.map(_.ctl.set(target)).flatten.void.runNow()
        } { t =>
          t.scrollIntoView()
        }
      }

    // scalastyle:off method.length
    def render(props: Props, state: State) = {
      val showSolidMenu = state.isScrolling || props.currPage
        .isInstanceOf[Posts]
      <.nav(
        Styles.menu(showSolidMenu),
        ^.id := "main-menu",
        <.a(
          Styles.blaarghBrand,
          ^.onClick ==> { evt: ReactEvent =>
            onClick(evt, Home)
          },
          ^.dangerouslySetInnerHtml := LinerleSVG.Image
        ),
        <.ul(^.key := "menu",
          <.li(^.key := "menu-item-1",
            ^.className := "menuitem",
            <.a(
              ^.className := "menuitem-label",
              ^.onClick ==> { evt: ReactEvent =>
                onClick(evt, Publications)
              },
              "Utgivelser"
            )
          ),
          <.li(^.key := "menu-item-2",
            ^.className := "menuitem",
            <.a(
              ^.className := "menuitem-label",
              ^.onClick ==> { evt: ReactEvent =>
                onClick(evt, Gallery)
              },
              "Galleri"
            )
          ),
          <.li(^.key := "menu-item-3",
            ^.className := "menuitem",
            <.a(
              ^.className := "menuitem-label",
              ^.onClick ==> { evt: ReactEvent =>
                onClick(evt, About)
              },
              "Om meg"
            )
          )
        )
      )
    }
    // scalastyle:on method.length
  }

  val component = ScalaComponent
    .builder[Props]("Menu")
    .initialState(State())
    .renderBackend[Backend]
    .configure(
      EventListener.install(
        eventType = "scroll",
        listener = _.backend.onScroll,
        target = _ => dom.window,
        useCapture = true
      )
    )
    .build

  def apply(siteConf: Config, currPage: View, ctl: RouterCtl[View]) =
    component(Props(siteConf, currPage, ctl))

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/components/Menu.scala